// Error boundary: https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/error_boundaries/
import React, { ReactNode, ErrorInfo } from 'react'
import { logger } from '../../utils/logger'
import { KatalMetricsPublisher } from '../../utils/metrics'
import { logWithTakt } from '../../utils/takt'
import * as KatalMetrics from '@amzn/katal-metrics'

interface Props {
  anchorId: string
  mobileView?: boolean
  children: ReactNode
  customMetricsPublisher?: KatalMetrics.Publisher
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  private metricsPublisher = KatalMetricsPublisher.newChildActionPublisherForMethod('ErrorBoundary')
  public state: State = {
    hasError: false,
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { mobileView, anchorId, customMetricsPublisher } = this.props
    const message = `Uncaught error on ${mobileView ? 'mobile' : 'desktop'} for anchor with id: ${anchorId}`
    logger.error(message, error, { errorInfo })

    if (customMetricsPublisher) {
      customMetricsPublisher.publishCounterMonitor(`${mobileView ? 'Mobile' : ''}Error`, 1)
    } else {
      this.metricsPublisher.publishCounterMonitor(`${mobileView ? 'Mobile' : ''}Error`, 1)
    }

    logWithTakt(anchorId, { event: 'rendering_error' })
    this.setState({ hasError: true })
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      // if there are render errors, return nothing
      return null
    }

    return this.props.children
  }
}
